import React from 'react';

import { type InlineMdNode, parseInlineMarkdown } from '@/lib/inlineMarkdown';

function renderNodes(nodes: InlineMdNode[], keyPrefix: string): React.ReactNode[] {
  return nodes.map((node, index) => {
    const key = `${keyPrefix}${index}`;
    if (node.type === 'text') return node.text;
    if (node.type === 'bold') {
      return (
        <strong key={key} className="font-nunito font-bold">
          {renderNodes(node.children, `${key}.`)}
        </strong>
      );
    }
    return (
      <em key={key} className="font-nunito italic font-normal">
        {renderNodes(node.children, `${key}.`)}
      </em>
    );
  });
}

/** Render inline markdown to React DOM (admin phone preview, etc.). */
export function InlineMarkdown({
  text,
  className,
  as: Tag = 'span',
}: {
  text: string;
  className?: string;
  as?: 'span' | 'p' | 'div' | 'h3';
}) {
  const nodes = parseInlineMarkdown(text);
  return <Tag className={className}>{renderNodes(nodes, 'm')}</Tag>;
}
